(() => {
  const IG_RE = /https?:\/\/(www\.)?instagram\.com\/(reel|p|tv)\/[A-Za-z0-9_\-]+\/?/i;

  function loadInstagram() {
    return new Promise((resolve) => {
      if (window.instgrm?.Embeds?.process) return resolve();

      if (document.querySelector('script[data-ig-embed]')) {
        const t = setInterval(() => {
          if (window.instgrm?.Embeds?.process) {
            clearInterval(t);
            resolve();
          }
        }, 100);
        return;
      }

      const s = document.createElement("script");
      s.async = true;
      s.src = "https://www.instagram.com/embed.js";
      s.setAttribute("data-ig-embed", "1");
      s.onload = () => resolve();
      document.body.appendChild(s);
    });
  }

  function extractUrlFromElement(el) {
    // Caso 1: hay un <a> a Instagram
    const a = el.querySelector?.('a[href*="instagram.com/"]');
    if (a && IG_RE.test(a.href)) return a.href;

    // Caso 2: texto plano con URL
    const txt = (el.textContent || "").trim();
    const m = txt.match(IG_RE);
    if (m) return m[0];

    return null;
  }

  function elementIsOnlyUrl(el, url) {
    // Si el párrafo contiene SOLO la URL (o el link)
    const txt = (el.textContent || "").trim().replace(/\s+/g, "");
    const cleanUrl = url.split("?")[0].replace(/\s+/g, "");
    // Shopify a veces imprime la URL tal cual o como texto del link
    return txt === cleanUrl || txt === (url.replace(/\s+/g, ""));
  }

  async function process() {
    const roots = document.querySelectorAll(".article-template__content, .rte");
    if (!roots.length) return;

    let changed = false;

    roots.forEach((root) => {
      root.querySelectorAll("p, li, div").forEach((el) => {
        if (el.dataset.igProcessed === "1") return;

        const url = extractUrlFromElement(el);
        if (!url) return;
        if (!elementIsOnlyUrl(el, url)) return;

        el.dataset.igProcessed = "1";

        const clean = url.split("?")[0];
        const bq = document.createElement("blockquote");
        bq.className = "instagram-media";
        bq.setAttribute("data-instgrm-permalink", clean);
        bq.setAttribute("data-instgrm-version", "14");
        bq.style.maxWidth = "540px";
        bq.style.margin = "20px auto";
        bq.style.width = "100%";

        el.innerHTML = "";
        el.appendChild(bq);
        changed = true;
      });
    });

    if (!changed) return;

    await loadInstagram();
    window.instgrm?.Embeds?.process?.();
  }

  document.addEventListener("DOMContentLoaded", process);
  document.addEventListener("shopify:section:load", process);
})();
